import { render } from "./Leads.vue?vue&type=template&id=e1ed485a&scoped=true&ts=true"
import script from "./Leads.vue?vue&type=script&lang=ts"
export * from "./Leads.vue?vue&type=script&lang=ts"

import "./Leads.vue?vue&type=style&index=0&id=e1ed485a&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ed485a"]])

export default __exports__